import { render, staticRenderFns } from "./click-to-jump.vue?vue&type=template&id=a53ac9ce&scoped=true"
import script from "./click-to-jump.vue?vue&type=script&lang=js"
export * from "./click-to-jump.vue?vue&type=script&lang=js"
import style0 from "./click-to-jump.vue?vue&type=style&index=0&id=a53ac9ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a53ac9ce",
  null
  
)

export default component.exports